import { render, staticRenderFns } from "./RolesPage.html?vue&type=template&id=703ec659&scoped=true&"
import script from "./RolesPage.ts?vue&type=script&lang=ts&"
export * from "./RolesPage.ts?vue&type=script&lang=ts&"
import style0 from "./RolesPage.scss?vue&type=style&index=0&id=703ec659&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ec659",
  null
  
)

export default component.exports